class BreadcrumbsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const collectionId = this.paramCollectionId;
    if (!collectionId) {
      return;
    }

    this.initializeDataset();

    const entry = this.findMenuHierarchy(collectionId);

    if (!entry) {
      return;
    }

    this.render(entry);
  }

  get mainMenu() {
    return this._mainMenu || [];
  }

  get paramCollectionId() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('from_collection');
  }

  initializeDataset() {
    const dataEl = this.querySelector('.breadcrumbs-data');
    if (!dataEl) return;

    try {
      this._mainMenu = JSON.parse(dataEl.textContent);
    } catch {
      console.log('Failed to parse main menu data for breadcrumbs');
      this._mainMenu = [];
    } finally {
      dataEl.remove();
    }

    this._breadcrumbMap = this.buildBreadcrumbMap(this._mainMenu);
  }

  buildBreadcrumbMap(menu) {
    const map = new Map();

    for (const link of menu) {
      for (const sublink of link.children || []) {

        // level 2
        if(sublink.id != null) {
          map.set(String(sublink.id), {
            grandParent: null,
            parent: null, // Set as null to reflect the same logic used in the liquid rendering
            self: sublink
          });
        }

        for (const child of sublink.children || []) {

          // level 3
          if(child.id != null) {
            map.set(String(child.id), {
              grandParent: link,
              parent: sublink,
              self: child
            });
          }
        }
      }
    }

    return map;
  }

  findMenuHierarchy(collectionId) {
    return this._breadcrumbMap?.get(String(collectionId)) || null;
  }

  render(entry) {
    const nav = this.querySelector('.breadcrumbs');
    if (!nav) return;

    const productItem = nav.querySelector('.breadcrumbs__item--product');

    // Clear previously injected breadcrumbs to avoid duplicates on re-render
    nav.querySelectorAll('[data-breadcrumb-injected]').forEach(el => el.remove());

    const homeLink = nav.querySelector('.breadcrumbs__item--home');

    homeLink?.classList.toggle(
      'hidden',
      !!(entry.grandParent || entry.parent)
    );

    if (entry.grandParent) {
      this.appendItem(nav, entry.grandParent.title, entry.grandParent.url, productItem);
    }

    if (entry.parent) {
      this.appendItem(nav, entry.parent.title, entry.parent.url, productItem);
    }

    if (entry.self) {
      this.appendItem(nav, entry.self.title, entry.self.url, productItem);
    }
  }

  appendItem(container, title, url = null, productItem = null) {
    const li = document.createElement('li');

    li.dataset.breadcrumbInjected = 'true';

    if (url) {
      const a = document.createElement('a');
      a.href = url;
      a.textContent = title;
      li.appendChild(a);
    } else {
      li.textContent = title;
    }

    if(productItem) {
      container.insertBefore(li, productItem);
    } else {
      container.appendChild(li);
    }
  }
}

if (!customElements.get('breadcrumbs-component')) {
  customElements.define('breadcrumbs-component', BreadcrumbsComponent);
}